import { render } from "./HistoriasFinal.vue?vue&type=template&id=7a3b3a96"
import script from "./HistoriasFinal.vue?vue&type=script&lang=js"
export * from "./HistoriasFinal.vue?vue&type=script&lang=js"

import "./HistoriasFinal.vue?vue&type=style&index=0&id=7a3b3a96&lang=css"
script.render = render

export default script